import { useCallback } from "react";
import { shipTypeData } from "src/mock/selectOptions";
import { useDispatch } from "src/redux/hooks";
import { setShipType } from "src/redux/slices/generatorSlice";

import CustomSelect from "../CustomSelect/CustomSelect";

interface IShipType {
  id: string;
  value: string;
  required: boolean;
}

const ShipType = ({ id, value, required }: IShipType) => {
  const dispatch = useDispatch();

  const additionalOnChange = useCallback(
    (newValue: string) => {
      dispatch(setShipType(newValue));
    },
    [dispatch],
  );

  return (
    <CustomSelect
      id={id}
      value={value}
      required={required}
      data={shipTypeData}
      onChange={additionalOnChange}
    />
  );
};

export default ShipType;
